module.exports = __webpack_public_path__ + "img/s2.404f2ddf.jpg";